import { useEffect, useState } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { ALIGN, ILandingSection, PersonContent } from "src/modules/pe-landing-module/data/interfaces"
import "../../../assets/css/Image.scss"
import { PersonPrimitive } from "../primitive"
import { getCssDemention, getCSSPartDemention } from "src/libs/utilities"
import DataContentEditor from "../landing-edit/editors/data-content-editor"
import usePosition from "src/modules/pe-landing-module/hooks/usePosition"

/* Protopia Ecosystem component */
export interface IPersonProps {
    section: ILandingSection
    data: PersonContent 
} 
const Person = ({data, ...props}: IPersonProps): JSX.Element => { 
    const {position}                = usePosition(data)
     const [marginLeft]      = useState<string>(!![ALIGN.END, ALIGN.MIDDLE ].find(e => e === data.horizontal_align)  || !data.horizontal_align ? "auto" : "0")
    const [marginRight]     = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.horizontal_align) || !data.horizontal_align ? "auto" : "0")
    const [marginTop]       = useState<string>(!![ALIGN.END, ALIGN.MIDDLE ].find(e => e === data.vertical_align) || !data.vertical_align ? "auto" : "0")
    const [marginBottom]    = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.vertical_align) || !data.vertical_align ? "auto" : "0")

    const [height, setHeight]       = useState<string>(getCssDemention( position.height || data.height, "fit-content" ))
    useEffect(() => {
        addCSSClass(
            `landing-person-${props.section.id}`,
            `.landing-person-${props.section.id} {
                margin-left: ${marginLeft};
                margin-right: ${marginRight};
                margin-top: ${marginTop};
                margin-bottom: ${marginBottom};
                max-height: ${ height };
                height: ${ height };
                max-width: 500px; 
                .landing-image-link {
                    width: auto!important;

                }
                .user-avatar {
                    width: ${ getCSSPartDemention( data?.data?.avatarWidth, "90px") };
                    height: ${ getCSSPartDemention( data?.data?.avatarHeight, "90px") };
                    border-radius: ${ getCSSPartDemention( data?.data?.border?.borderRound?.border, "50%") };
                    border-width: ${ getCSSPartDemention( data?.data?.border?.borderWidth, "1px") };
                    border-color: ${ data?.data?.border?.borderColor };
                    border-style: ${ data?.data?.border?.borderStyle || "solid"};
                    background-image: url(${data?.data?.user?.avatar});
                }
            }
            `
        )
        return () => {
            removeCSSClass(`landing-person-${props.section.id}`)
        }
    },[]) 
    return <div className={`landing-person-container landing-content-container landing-person-${props.section.id}`} data-type={data.type} data-content-id={data.id}>
        <div>
            <PersonPrimitive 
                primitive = { data?.data } 
            />
            <DataContentEditor data={data} section={props.section} />
        </div>
    </div>
}
export default Person
 